export default {
  bind (el, binding) {
    if (!el) return
    if (!binding.value) {
      el.removeAttribute('data-featureKey')
      return
    }
    // if binding.value is array, join it with a comma
    if (Array.isArray(binding.value)) {
      el.setAttribute('data-featureKey', binding.value.join('、'))
    } else {
      el.setAttribute('data-featureKey', binding.value)
    }
  },
  update (el, binding) {
    if (!el) return
    if (!binding.value) {
      el.removeAttribute('data-featureKey')
      return
    }

    // if binding.value is array, join it with a comma
    if (Array.isArray(binding.value)) {
      el.setAttribute('data-featureKey', binding.value.join('、'))
    } else {
      el.setAttribute('data-featureKey', binding.value)
    }
  },
}
